import { useState } from "react";

export default function DisclaimerPage() {
    const [agreed, setAgreed] = useState(false);

    return (
        <div
            className="min-vh-100"
            style={{
                backgroundColor: "#f0f9eb",
                padding: "16px",
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
                color: "#2f5d2f",
            }}
        >
            <div className="container px-0">
                <div
                    className="mx-auto bg-white"
                    style={{
                        maxWidth: "520px",
                        borderRadius: "16px",
                        padding: "18px 16px",
                        boxShadow: "0 8px 22px rgba(0,0,0,0.05)",
                        border: "1px solid #dcebd6",
                    }}
                >
                    {/* TITLE */}
                    {/* <div
                        className="text-center mb-3"
                        style={{
                            backgroundColor: "#43861A",
                            borderRadius: "12px",
                            padding: "14px",
                        }}
                    >
                        <h2
                            className="mb-0 fw-bold"
                            style={{
                                fontSize: "17px",
                                color: "#ffffff",
                            }}
                        >
                            Disclaimer
                        </h2>
                    </div> */}

                    {/* CONTENT */}
                    <ul className="list-unstyled mb-0">
                        {[
                            {
                                text: "Users cannot claim reward points as a matter of right. Reward points are non-transferable and do not confer any proprietary rights.",
                                highlight: true,
                            },
                            {
                                text: "Reward points may be encashed or exchanged only for products specifically offered. Once an option is selected, it cannot be changed or altered.",
                            },
                            {
                                text: "Products chosen for redemption will be supplied strictly subject to availability at the time of fulfillment.",
                            },
                            {
                                text: "Images shown are for representative purposes only and may differ from the actual products.",
                            },
                            {
                                text: "In all circumstances, the company’s liability is limited solely to the value of the reward points.",
                                highlight: true,
                            },
                            {
                                text: "Reward points may expire if not redeemed within the specified validity period. The company reserves the right to modify, suspend, or terminate the program or redemption options at any time without prior notice. Misuse or fraudulent activity may result in forfeiture of points.",
                            },
                        ].map((item, index) => (
                            <li
                                key={index}
                                className="mb-3"
                                style={{
                                    position: "relative",
                                    padding: "12px 14px 12px 32px",
                                    backgroundColor: item.highlight ? "#edf7e6" : "#f9fdf6",
                                    borderRadius: "10px",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                    color: item.highlight ? "#2f5d2f" : "#465946",
                                    fontWeight: item.highlight ? 600 : 400,
                                    borderLeft: item.highlight
                                        ? "4px solid #9fcf9b"
                                        : "none",
                                }}
                            >
                                <span
                                    style={{
                                        position: "absolute",
                                        left: "14px",
                                        top: "12px",
                                        fontSize: "20px",
                                        color: "#9fcf9b",
                                    }}
                                >
                                    •
                                </span>
                                {item.text}
                            </li>
                        ))}
                    </ul>

                    {/* AGREE SECTION */}
                    {/* <div
                        className="mt-3 pt-3"
                        style={{ borderTop: "1px solid #e0efda" }}
                    >
                        <div className="form-check mb-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={agreed}
                                onChange={(e) => setAgreed(e.target.checked)}
                                style={{ accentColor: "#9fcf9b" }}
                                id="agreeCheck"
                            />
                            <label
                                className="form-check-label"
                                htmlFor="agreeCheck"
                                style={{ fontSize: "14px", color: "#465946" }}
                            >
                                I have read and understood the disclaimer and agree to the terms.
                            </label>
                        </div>

                        <button
                            className="btn w-100 fw-semibold"
                            disabled={!agreed}
                            style={{
                                padding: "13px",
                                borderRadius: "12px",
                                fontSize: "15px",
                                backgroundColor: agreed ? "#9fcf9b" : "#cfe8c9",
                                color: agreed ? "#ffffff" : "#2f5d2f",
                                opacity: agreed ? 1 : 0.6,
                                cursor: agreed ? "pointer" : "not-allowed",
                            }}
                            onClick={() => {
                                if (agreed) {
                                    console.log("Disclaimer accepted");
                                    // 👉 API call / navigation / WebView close
                                }
                            }}
                        >
                            I Agree
                        </button>
                    </div> */}
                </div>
            </div>
        </div>
    );
}